<template>
  <div
    class="
      flex-1
      bg-gray-500
      relative
      text-base
      leading-none
      text-white
      p-5
      px-5
      rounded-lg
      flex
      justify-between
      items-center
      input-text-search
    "
  >
    <Icon id="search" />
    <div
      @click="$emit('input', '')"
      class="relative z-10 cursor-pointer"
      v-if="value.length"
    >
      <Icon id="cancel" />
    </div>
    <input
      :value="value"
      @input="$emit('input', $event.target.value)"
      placeholder="Songtitle"
      class="placeholder-gray-400 absolute w-full h-full pl-16 pr-16 left-0 bg-transparent z-0"
    />
  </div>
</template>

<script lang="ts">
import { Vue, Component, Prop } from 'vue-property-decorator'

@Component({})
export default class InputTextSearch extends Vue {
  @Prop() value!: string
}
</script>
